import type { BaseRecord } from '@pankod/refine-core'

export function fromRecordToFormData<T extends BaseRecord>(object: T) {
  const formData = new FormData()
  Object.keys(object).forEach((key) => formData.append(key, object[key]))
  return formData
}
